<script>
    /*
    * Mixin_Home_Editors.js
    *
    * Description: Mixin File for Home.vue. Includes: Add Editors. Change Status.
    * Description: Delete Duty.
    *
    * This file is part of: "http://apps.sundair.com/", "SunCrew2 - Crewplanning"
    * Copyright 2018,2019,2020,2021,2022,2023 Sundair GmbH
    * Contact:  http://www.sundair.com/
    * @author Christian Arp <christian.arp@sundair.com>
    * @author Learek <michael.broeker@sundair.com>
    * @author Phillip Alsleben <phillip.alsleben@sundair.com>
    *
    */
    import Vue from 'vue';
    import { mapActions } from 'vuex';
    import moment from 'moment';
    import { eventBus } from '../../../../main';


    export default {
        name: 'CrewplanningHomeMixinEditors',

        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_Home.vue >>> created');


		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_Home.vue >>> destroyed');


		}, // eo function destroyed()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                // >>> ------------------------------------

            ]),


            /******************************************************************* 'Listeners - Scheduler 'Calendar' - Add Events'
            * Listeners:
            *******************************************************************/
            /******************************************************************* 'single'
            * onClick_Add_Available()
            *
            * Desc: Add everything for create 'AVAILABLE'.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onClick_Add_Available: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_Add_Available');
                // Guard: Check Calendar Grant.
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.available' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create AVAILABLE.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore          : null, // update
                    resourceId          : null, // update
                    eventRecord         : null, // update
                    resourceRecord      : theData.resourceRecord, // create
                    addDate             : theData.date, // create
                    eventName           : 'AVAILABLE',
                    editorMode          : 'create',
                    showEditorAvailable : true,
                });

            }, // eo function onClick_Add_Available()


            /*******************************************************************
            * onClick_Add_Freeday()
            *
            * Desc: Add everything for create 'FREEDAY'.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.

            * @param {Object} theData (date, resourceRecord)
            */
            onClick_Add_Freeday: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_Add_Freeday');
                // Guard: Check Calendar Grant.
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.freeday' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create FREEDAY.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore              : null, // update
                    resourceId              : null, // update
                    eventRecord             : null, // update
                    resourceRecord          : theData.resourceRecord, // create
                    addDate                 : theData.date, // create
                    eventName               : 'FREEDAY',
                    editorMode              : 'create',
                    showEditorFreeday       : true,
                });

            }, // eo function onClick_Add_Freeday()


            /*******************************************************************
            * onClick_Add_Reserve()
            *
            * Desc: Add everything for create 'RESERVE'.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onClick_Add_Reserve: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_Add_Reserve');
                // Guard: Check Calendar Grant.
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.reserve' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create RESERVE.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore              : null, // update
                    resourceId              : null, // update
                    eventRecord             : null, // update
                    resourceRecord          : theData.resourceRecord, // create
                    addDate                 : theData.date, // create
                    eventName               : 'RES',
                    editorMode              : 'create',
                    showEditorReserve       : true,
                });

            }, // eo function onClick_Add_Reserve()


            /*******************************************************************
            * onClick_Add_Vacation()
            *
            * Desc: Add everything for create 'VACATION'.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onClick_Add_Vacation: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_Add_Vacation');
                // Guard: Check Calendar Grant.
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.vacation' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create VACATION.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore          : null,                                 // update
                    resourceId          : null,                                 // update
                    eventRecord         : null,                                 // update
                    resourceRecord      : theData.resourceRecord,               // create
                    addDate             : theData.date,                         // create
                    eventName           : 'VACATION',
                    editorMode          : 'create',
                    showEditorVacation  : true,
                });

            }, // eo function onClick_Add_Vacation()




            /******************************************************************* 'multiple'
            * onClick_Add_Multiple_Dayoffs()
            *
            * Desc: Add everything for create multiple 'DAYOFF's.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onClick_Add_Multiple_Dayoffs: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_Add_Multiple_Dayoffs');
                // Guard: Check Calendar Grant.
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.dayoff' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create DAYOFF.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore              : null, // update
                    resourceId              : null, // update
                    eventRecord             : null, // update
                    resourceRecord          : theData.resourceRecord, // create
                    addDate                 : theData.date, // create
                    eventName               : 'DAYOFF',
                    editorMode              : 'create',
                    showEditorDayoff        : true,
                });

            }, // eo function onClick_Add_Multiple_Dayoffs()


            /*******************************************************************
            * onClick_Add_Multiple_Hotels()
            *
            * Desc: Add everything for create multiple 'HOTEL's.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onClick_Add_Multiple_Hotels: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_Add_Multiple_Hotels');
                // Guard: Check Calendar Grant.
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.hotel' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create HOTEL.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore              : null, // update
                    resourceId              : null, // update
                    eventRecord             : null, // update
                    resourceRecord          : theData.resourceRecord, // create
                    addDate                 : theData.date, // create
                    eventName               : 'HOTEL',
                    editorMode              : 'create',
                    showEditorHotel         : true,
                });

            }, // eo function onClick_Add_Multiple_Hotels()


            /*******************************************************************
            * onAdd_Multiple_Meetings()
            *
            * Desc: Add everything for create multiple 'MEETING's.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onAdd_Multiple_Meetings: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onAdd_Multiple_Meetings');
                // Guard: Check Calendar Grant.
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.meeting' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create MEETING.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore              : null, // update
                    resourceId              : null, // update
                    eventRecord             : null, // update
                    resourceRecord          : theData.resourceRecord, // create
                    addDate                 : theData.date, // create
                    eventName               : 'MEETING',
                    editorMode              : 'create',
                    showEditorMeeting       : true,
                });

            }, // eo function onAdd_Multiple_Meetings()


            /*******************************************************************
            * onAdd_Multiple_Office()
            *
            * Desc: Add everything for create multiple 'OFFICE's.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onAdd_Multiple_Office: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onAdd_Multiple_Office');
                // Guard: Check Calendar Grant.
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.office' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create OFFICE.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore              : null, // update
                    resourceId              : null, // update
                    eventRecord             : null, // update
                    resourceRecord          : theData.resourceRecord, // create
                    addDate                 : theData.date, // create
                    eventName               : 'OFFICE',
                    editorMode              : 'create',
                    showEditorOffice        : true,
                });

            }, // eo function onAdd_Multiple_Office()


            /*******************************************************************
            * onAdd_Multiple_Proceedings()
            *
            * Desc: Add everything for create multiple 'PROCEEDING's.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onAdd_Multiple_Proceedings: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onAdd_Multiple_Proceedings');
                // Guard: Check Calendar Grant.
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.proceeding' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create PROCEEDING.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore              : null, // update
                    resourceId              : null, // update
                    eventRecord             : null, // update
                    resourceRecord          : theData.resourceRecord, // create
                    addDate                 : theData.date, // create
                    eventName               : 'PROCEEDING',
                    editorMode              : 'create',
                    showEditorProceeding         : true,
                });

            }, // eo function onAdd_Multiple_Proceedings()


            /*******************************************************************
            * onAdd_Multiple_Sickness()
            *
            * Desc: Add everything for create multiple 'SICKNESS's.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onAdd_Multiple_Sickness: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onAdd_Multiple_Sickness');
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.sickness' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create SICKNESS.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore              : null, // update
                    resourceId              : null, // update
                    eventRecord             : null, // update
                    resourceRecord          : theData.resourceRecord, // create
                    addDate                 : theData.date, // create
                    eventName               : 'STANDBY',
                    editorMode              : 'create',
                    showEditorSickness      : true,
                });

            }, // eo function onAdd_Multiple_Sickness()


            /*******************************************************************
            * onAdd_Multiple_Standby()
            *
            * Desc: Add everything for create multiple 'STANDBY's.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onAdd_Multiple_Standby: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onAdd_Multiple_Standby');
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.standby' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create STANDBY.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore              : null, // update
                    resourceId              : null, // update
                    eventRecord             : null, // update
                    resourceRecord          : theData.resourceRecord, // create
                    addDate                 : theData.date, // create
                    eventName               : 'STANDBY',
                    editorMode              : 'create',
                    showEditorStandby       : true,
                });

            }, // eo function onAdd_Multiple_Standby()


            /*******************************************************************
            * onAdd_Multiple_Trainings()
            *
            * Desc: Add everything for create multiple 'TRAINING's.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onAdd_Multiple_Trainings: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onAdd_Multiple_Trainings');
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.training' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create TRAINING.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore              : null, // update
                    resourceId              : null, // update
                    eventRecord             : null, // update
                    resourceRecord          : theData.resourceRecord, // create
                    addDate                 : theData.date, // create
                    eventName               : 'TRAINING',
                    editorMode              : 'create',
                    showEditorTraining      : true,
                });

            }, // eo function onAdd_Multiple_Trainings()


            /*******************************************************************
            * onAdd_Multiple_UnableFlights()
            *
            * Desc: Add everything for create multiple 'UNABLEFLIGHT's.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onAdd_Multiple_UnableFlights: function(theData) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onAdd_Multiple_UnableFlights');
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.unableflight' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create UNABLEFLIGHT.'
                    });
                    return
                }


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [theData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                Object.assign(this, {
                    eventStore              : null, // update
                    resourceId              : null, // update
                    eventRecord             : null, // update
                    resourceRecord          : theData.resourceRecord, // create
                    addDate                 : theData.date, // create
                    eventName               : 'UNABLEFLIGHT',
                    editorMode              : 'create',
                    showEditorUnableFlight  : true,
                });

            }, // eo function onAdd_Multiple_UnableFlights()




            /******************************************************************* 'Listeners - Switch Duty'
            * Listeners:
            *******************************************************************/
            /******************************************************************* 'Click'
            * onClick_SwitchDuty()
            *
            * Desc: Switch Duties of 2 Employees.
            * Note: Check if edit in past is allowed.
            * Note: Check for Trainings Flights on this Date and Ressources (Check Roles).
            *
            * @param {Object} theData (date, resourceRecord)
            */
            onClick_SwitchDuty: function(theData) {

                let me = this,
                    isThisATrainingsFlight = false,
                    markedRessources = this.get_selectedMultiResources;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_SwitchDuty');
                // >>> Backup the Data for later use ----------------
                this.backupTheData = theData; // backup the Data for later use

                // >>> Check if there are Trainings Flights ---------
                isThisATrainingsFlight = this.get_areThereTrainingsFlightsOnDateAndResources({ markedRessources: markedRessources, theData: theData})
                if (isThisATrainingsFlight === true) {
                    this.dialogSwitchDutyTrainingFlight = true;
                    return;
                }

                if (isThisATrainingsFlight === false) {
                    this.onClick_SwitchDuty_Agree();
                }

            }, // eo function onClick_SwitchDuty()


            /******************************************************************* 'Click'
            * onClick_SwitchDuty()
            *
            * Desc: Switch Duty => Training Flight => Agree.
            * Note:
            *
            */
            onClick_SwitchDuty_Agree: function() {

                let me = this,
                    markedRessources = this.get_selectedMultiResources,
                    params = {
                        idResource1: [],
                        idResource2 : [],
                        date: [],
                    };


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_SwitchDuty_Agree');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [this.backupTheData.date], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                if (this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.switchduty' })) {

                    if (markedRessources.length === 2) {
                        params = {
                            idResource1 : markedRessources[0].id,
                            idResource2 : markedRessources[1].id,
                            date        : moment(this.backupTheData.date).format('YYYY-MM-DDT04:00:ss+0000'),
                        };
                        this.actn_switch_Duty(params);
                    } else {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Please select exactly 2 ressources for a switch duty.'
                        });
                    }

                } else {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create SWITCHDUTY.'
                    });
                }


                this.dialogSwitchDutyTrainingFlight = false; // close the Dialog

            }, // eo function onClick_SwitchDuty_Agree()


            /******************************************************************* 'Updated'
            * onUpdate_SwitchDuty()
            *
            * Desc: Successful Call => emits 'updatedswitchduty' Event.
            * Desc: anc Change Data in Scheduler.
            * Note: There are 2 Steps:
            * Note: a) Delete all 'older' Duties.
            * Note: b) Create new ones.
            *
            * @param {Object} payload (Calls Payload)
            */
            onUpdate_SwitchDuty: function(payload){

                let me = this,
                    recsToAdd = [],
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onUpdate_SwitchDuty');
                this.actn_set_SelectedMultiEvents([]);

                // >>> Step 1: Delete 'older' Duties ------
                this.onUpdate_SwitchDuty_DeleteStep(payload.switchDutyInfo);

                // >>> Step 2: Create newer Duties --------
                recsToAdd = me.$build_MultipleDuties(payload.breakdownResponse);
                setTimeout(function(){
                    scheduler.eventStore.add(recsToAdd);
                },500);

            }, // eo function onUpdate_SwitchDuty()


            /******************************************************************* 'Delete'
            * onUpdate_SwitchDuty_DeleteStep()
            *
            * Desc: Delete 'older' Duties from the Switch Duty Ressources.
            * Note:
            *
            * @param {Object} switchDutyInfo (Duties to delete)
            */
            onUpdate_SwitchDuty_DeleteStep: function(switchDutyInfo){

                let me = this,
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onUpdate_SwitchDuty_DeleteStep');
                switchDutyInfo.forEach((resource) => {
                    resource.deleteDuties.forEach((duty) => {
                        if (duty.type === 'FLIGHT') { // FLIGHT
                            scheduler.eventStore.forEach(rec => {
                                if ((rec.originalId === duty.id) && (rec.name === 'FLIGHT' || rec.name === 'CHECKIN' || rec.name === 'CHECKOUT' )) {
                                    scheduler.eventStore.remove(rec);
                                }
                            });
                            scheduler.eventStore.forEach(rec => {
                                if ((rec.originalId === duty.id) && (rec.name === 'FLIGHT' || rec.name === 'CHECKIN' || rec.name === 'CHECKOUT' )) {
                                    scheduler.eventStore.remove(rec);
                                }
                            });
                        }

                        if (duty.type === 'TRAINING') { // TRAINING
                            scheduler.eventStore.forEach(rec => {
                                if ((rec.originalId === duty.id) && (rec.name === 'TRAINING')) {
                                    scheduler.eventStore.remove(rec);
                                }
                            })
                        }

                        if (duty.type === 'HOTEL') { // HOTEL
                            scheduler.eventStore.forEach(rec => {
                                if ((rec.originalId === duty.id) && (rec.name === 'HOTEL')) {
                                    scheduler.eventStore.remove(rec);
                                }
                            })
                        }

                        if (duty.type === 'PROCEEDING') { // PROCEEDING
                           scheduler.eventStore.forEach(rec => {
                                if ((rec.originalId === duty.id) && (rec.name === 'PROCEEDING')) {
                                    scheduler.eventStore.remove(rec);
                                }
                            })
                        }

                        if (duty.type === 'BREAK') { // BREAK
                            scheduler.eventStore.forEach(rec => {
                                if ((rec.originalId === duty.id) && (rec.name !== 'FLIGHT' && rec.name !== 'CHECKIN' && rec.name !== 'CHECKOUT' && rec.name !== 'HOTEL' && rec.name !== 'TRAINING' && rec.name !== 'PRO')) {
                                    scheduler.eventStore.remove(rec);
                                }
                            })
                        }
                    });
                });

            }, // eo function onUpdate_SwitchDuty_DeleteStep()




            /******************************************************************* 'Listeners - Change(d) Status
            * Listeners:
            *******************************************************************/
            /******************************************************************* 'Sickness Multiple Change'
            * onClick_ChangeStatus_MultipleSicknesses()
            *
            * Desc: Handle 'Set SICKNESSES - Status'. Multiple.
            * Note: Check Calendar Grant.
            *
            * @param {Object} eventRecord (Clicked Record)
            */
            onClick_ChangeStatus_MultipleSicknesses: function(eventRecord) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_ChangeStatus_MultipleSicknesses');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [eventRecord.data.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                if (this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.sickness' })) {

                    if (this.get_selectedMultiEvents('SICKNESS').length === 0) {
                        this.actn_set_SelectedMultiEvents(Array(eventRecord));   // Save in State
                    }

                    if (eventRecord.name === 'SICKNESS') {
                        Object.assign(this, {
                            eventStore                      : eventRecord.stores[0],
                            resourceId                      : eventRecord.data.resourceId,
                            eventRecord                     : eventRecord,
                            showEditorSicknessChangeStatus  : true
                        });
                    }

                } else {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to change/activate SICKNESS.'
                    });
                }

            }, // eo function onClick_ChangeStatus_MultipleSicknesses()


            /******************************************************************* 'Sickness Multiple Changed'
            * onChangedStatus_MultipleSicknesses_Finally()
            *
            * Desc: Successful Call => emits 'changedstatusmultiplesicknesses' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of call:actn_changestatus_Multiple_Sicknesses
            * Note: for buildEventNote.
            *
            * @param {Object} response (Response from Call)
            */
            onChangedStatus_MultipleSicknesses_Finally: function(response){

                let me = this,
                    rec = null,
                    tooltipData = null,
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onChangedStatus_MultipleSicknesses_Finally');
                if (response.length) {
                    response.forEach(sickness => {
                        rec = scheduler.eventStore.findByField('originalId', sickness.id);

                        tooltipData = me.$buildEventNote(sickness); // Catch after 'requested was set!: Important
                        rec[0].data.set({ nameEvent: tooltipData.nameEvent });
                    });
                }


                // >>> close the editor now ---------------
                me.showEditorSicknessChangeStatus = false;
                me.onScheduler_DeselectAll(); // #401

            }, // eo function onChangedStatus_MultipleSicknesses_Finally()




            /******************************************************************* 'Change Status Hotel Single'
            * onClick_ChangeStatus_SingleHotel()
            *
            * Desc: Handle 'Set HOTEL - Status'. Single.
            * Note:
            * TODO: Really 'transporting' entire rec ?
            *
            * @param {Object} rec (Clicked Record)
            */
            onClick_ChangeStatus_SingleHotel: function(rec) {

                let me = this,
                    params = {},
                    status = '';


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_ChangeStatus_SingleHotel');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [rec.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                // >>> ------------------------------------ Call
                if (rec.nameEvent === 'HOTEL (pending)') {
                    status = 'BOOKED';
                } else {
                    status = 'PENDING';
                }

                params = {
                    'hotelId': rec.originalId,
                    'status': status, // 'PENDING', 'BOOKED'
                    'rec': rec
                };

                this.actn_set_HotelStatus(params);

            }, // eo function onClick_ChangeStatus_SingleHotel()


            /******************************************************************* 'Change Status Hotels Multiple'
            * onClick_ChangeStatus_MultipleHotels()
            *
            * Desc: Handle 'Set HOTEL - Status'. Multiple.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} rec (Clicked Record)
            */
            onClick_ChangeStatus_MultipleHotels: function(rec) {

                let me = this,
                    markedEvents = null,
                    startDatesArray = [],
                    myParams = {
                        params: {
                            idStays: [],
                            status: ''
                        },
                        recs: []
                    };


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_ChangeStatus_MultipleHotels');
                if (this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.hotel' })) {

                    if (this.get_selectedMultiEvents('HOTEL').length === 0) {
                        this.actn_set_SelectedMultiEvents(Array(rec));   // Save in State
                    }

                    markedEvents = this.get_selectedMultiEventsEntireRecord;
                    if (markedEvents.length > 0) {
                        markedEvents.forEach(event => {
                            if (event.data.name !== 'FLIGHT' && event.data.name !== 'CHECKIN' && event.data.name !== 'CHECKOUT') {
                                if (event.data.name === 'HOTEL') {
                                    myParams.params.idStays.push(event.data.originalId);
                                    myParams.recs.push(event);
                                    startDatesArray.push(event.data.startDate);
                                }
                            }
                        });
                    }


                    if (!Vue.prototype.$isActionAllowed({ datesToCheck: startDatesArray, isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Note: Dear User, no Changes in Past possible.'
                        });
                        return;
                    }

                    // >>> ------------------------------------ Call
                    if (rec.nameEvent === 'HOTEL (pending)') {
                        myParams.params.status = 'BOOKED';
                    } else {
                        myParams.params.status = 'PENDING';
                    }

                    this.actn_set_HotelStatusMultiple(myParams);

                } else {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to change/activate HOTEL.'
                    });
                }

            }, // eo function onClick_ChangeStatus_MultipleHotels()


            /******************************************************************* 'Change Status Hotels Multiple Finally - Emit'
            * onClick_ChangeStatus_MultipleHotels_Finally()
            *
            * Desc: Handle 'Change Status Multiple Hotels Finally'.
            * Note:
            *
            * @param {Object} myObject (See: 'actn_set_HotelStatusMultiple')
            */
            onClick_ChangeStatus_MultipleHotels_Finally: function(myObject) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_ChangeStatus_MultipleHotels_Finally');
                myObject.recs.forEach(rec => {
                    rec.nameEvent = 'HOTEL (' + myObject.status.toLowerCase() + ')';
                    rec.hotelObject.status = myObject.status.toUpperCase();
                });


                this.actn_set_SelectedMultiEvents([]); // send empty Array (reset), #244
                me.onScheduler_DeselectAll(); // #401

            }, // eo function onClick_ChangeStatus_MultipleHotels_Finally()


            /******************************************************************* 'Change Status Proceeding'
            * onClick_ChangeStatus_SingleProceeding()
            *
            * Desc: Handle 'Set PROCEEDING - Status'.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * TODO: Really 'transporting' entire rec ?
            *
            * @param {Object} rec (Clicked Record)
            */
            onClick_ChangeStatus_SingleProceeding: function(rec) {

                let me = this,
                    params = {},
                    status = '',
                    style = '';


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_ChangeStatus_SingleProceeding');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [rec.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                if (this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.proceeding' })) {

                    // >>> ------------------------------------ Call
                    if (rec.style === 'border: 1px solid red !important;') { // IS 'PENDING' .. SET 'BOOKED'
                        status = 'BOOKED';
                        style = null;
                    } else { // IS 'BOOKED' .. SET 'PENDING'
                        status = 'PENDING';
                        style = 'border: 1px solid red !important;';
                    }

                    params = {
                        'proceedingId': rec.originalId,
                        'status': status, // 'PENDING', 'BOOKED'
                        'style': style,
                        'rec': rec
                    };

                    this.actn_set_ProceedingStatus(params);

                } else {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to change/activate PROCEEDING.'
                    });
                }

            }, // eo function onClick_ChangeStatus_SingleProceeding()


            /******************************************************************* 'Change Activated Dayoff'
            * onClick_ChangeActivated_SingleDayoff()
            *
            * Desc: Handle 'Set DAYOFF - Activated'.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * TODO: Really 'transporting' entire rec ?
            *
            * @param {Object} rec (Clicked Record)
            */
            onClick_ChangeActivated_SingleDayoff: function(rec) {

                let me = this,
                    params = {},
                    innerParams = {},
                    style = '',
                    activated = null;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_ChangeActivated_SingleDayoff');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [rec.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                if (this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.dayoff' })) {

                    // >>> ------------------------------------ Call
                    if (rec.activated === true) {   // IS true .. SET false
                        activated = false;
                        style = null;
                    } else {                        // IS false .. SET true
                        activated = true;
                        // style = 'border-color: #27ca37; color: #27ca37;';
                        style = 'color: white; background: repeating-linear-gradient(45deg, #ffe81c,#ffe81c 10px,#c0af1a 10px,#c0af1a 20px);';

                    }

                    if (rec.dutyComment !== null) {
                        if (style !== null) {
                            style = style + ' border-right: 3px dotted #000;';
                        } else {
                            style = ' border-right: 3px dotted #000;';
                        }
                    }


                    innerParams = {
                        id              : rec.originalId,
                        idResource      : rec.resourceId,
                        from            : moment(rec.startDate).format('YYYY-MM-DDT05:00:ss+0000'),
                        to              : moment(rec.startDate).format('YYYY-MM-DDT21:00:ss+0000'), // same day
                        requested       : rec.requested,
                        remainingDayoff : rec.remainingDayOff,
                        type            : 'DAYOFF',
                        status          : 'PLANNED',
                        activated       : activated,
                        dutyComment     : rec.dutyComment !== '' ? rec.dutyComment : null,
                    };

                    params = {
                        innerParams     : innerParams,
                        style           : style,
                        rec             : rec
                    };

                    this.actn_set_DayoffActivated(params);

                } else {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to change/activate DAYOFF.'
                    });
                }

            }, // eo function onClick_ChangeActivated_SingleDayoff()


            /******************************************************************* 'Change Activated Freeday'
            * onClick_ChangeActivated_SingleFreeday()
            *
            * Desc: Handle 'Set FREEDAY - Activated'.
            * Note: Check Calendar Grant.
            * Note: Check if edit in past is allowed.
            *
            * TODO: Really 'transporting' entire rec ?
            *
            * @param {Object} rec (Clicked Record)
            */
            onClick_ChangeActivated_SingleFreeday: function(rec) {

                let me = this,
                    params = {},
                    innerParams = {},
                    style = null,
                    activated = null;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_ChangeActivated_SingleFreeday');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [rec.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                if (this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.freeday' })) {

                    // >>> ------------------------------------ Call
                    if (rec.activated === true) {   // IS true .. SET false
                        activated = false;
                        style = null;
                    } else {                        // IS false .. SET true
                        activated = true;
                        // style = 'border-color: #27ca37; color: #27ca37;';
                        style = 'color: white; background: repeating-linear-gradient(45deg, #ffe81c,#ffe81c 10px,#c0af1a 10px,#c0af1a 20px)';
                    }

                    if (rec.dutyComment !== '') {
                        if (style !== null) {
                            style = style + ' border-right: 3px dotted #000;';
                        } else {
                            style = ' border-right: 3px dotted #000;';
                        }
                    }


                    innerParams = {
                        id              : rec.originalId,
                        idResource      : rec.resourceId,
                        from            : moment(rec.startDate).format('YYYY-MM-DDT05:00:ss+0000'),
                        to              : moment(rec.startDate).format('YYYY-MM-DDT21:00:ss+0000'), // same day
                        requested       : rec.requested,
                        remainingDayoff : rec.remainingDayOff,
                        type            : 'FREEDAY',
                        status          : 'PLANNED',
                        activated       : activated,
                        dutyComment     : rec.dutyComment !== '' ? rec.dutyComment : null,
                    };

                    params = {
                        innerParams     : innerParams,
                        style           : style,
                        rec             : rec
                    };


                    this.actn_set_FreedayActivated(params);

                } else {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to change/activate FREEDAY.'
                    });
                }

            }, // eo function onClick_ChangeActivated_SingleFreeday()


            /******************************************************************* 'Change Activated Standby'
            * onClick_Standby_Activate()
            *
            * Desc:
            * Note: Check Calendar Grant.
            *
            * @param {Object} eventRecord (Clicked Record)
            */
            onClick_Standby_Activate: function(eventRecord) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_ChangeActivated_SingleFreeday');
                if (this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.standby' })) {
                    if (eventRecord.name === 'STANDBY') {
                        Object.assign(this, {
                            eventStore                  : eventRecord.stores[0],
                            resourceId                  : eventRecord.data.resourceId,
                            eventRecord                 : eventRecord,
                            showEditorStandbyActivate   : true
                        });
                    }
                } else {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to change/activate STANDBY.'
                    });
                }

            }, // eo function onClick_Standby_Activate()




            /******************************************************************* 'Listeners - Deleting Duties'
            * Listeners:
            *******************************************************************/
            /******************************************************************* 'Delete single Duty - Emit'
            * onClick_Delete_SingleDuty()
            *
            * Desc: Handle 'Delete Single Duty'.
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} rec (Clicked Record)
            */
            onClick_Delete_SingleDuty: function(rec) {

                let me = this,
                    params = {};

                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_Delete_SingleDuty');
                // >>> --------------------------------------------------------- showin dialog?
                if (this.agreeDeleteSingle === false) { // not yet agreed
                    if (!Vue.prototype.$isActionAllowed({ datesToCheck: [rec.data.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Note: Dear User, no Changes in Past possible.'
                        });
                        return;
                    }
                }

                if (this.agreeDeleteSingle === false) { // not yet agreed
                    if (this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.' + rec.name.toLowerCase() })) {
                        this.dialogDeleteSingle = true;
                        this.tmpDeleteSingleRecord = rec; // save rec temp
                    } else {
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Attention: Dear User, your are not allowed to delete ' + rec.name.toUpperCase() + '.'
                        });
                    }
                }


                if (this.agreeDeleteSingle === true) { // agreed
                    params = {
                        'idToDelete': this.tmpDeleteSingleRecord.originalId,
                        'type': this.tmpDeleteSingleRecord.name,
                        'rec': this.tmpDeleteSingleRecord
                    };

                    this.agreeDeleteSingle = false;
                    this.dialogDeleteSingle = false;
                    this.actn_delete_SingleDuty(params);
                }

            }, // eo function onClick_Delete_SingleDuty()


            /******************************************************************* 'Delete single Duty Finally - Emit'
            * onClick_Delete_SingleDuty_Finally()
            *
            * Desc: Handle 'Delete Single Duty Finally'.
            * Note: Delete the old Way. Via transported recs.
            * Note: Delete the new Way. Via apis response.
            * Note: In Case of DAYOFF ... Jonas deletes more than requested.
            *
            * @param {Object} rec (Clicked Record)
            */
            onClick_Delete_SingleDuty_Finally: function(objectOfRecords) {

                let me = this,
                    rec = null,
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_Delete_SingleDuty_Finally');
                // >>> 1. getting back Array --------------
                if (objectOfRecords.response.length > 0) {                      // New: 567
                    objectOfRecords.response.forEach(duty => {
                        rec = scheduler.eventStore.findByField('originalId', duty.id);
                        if (rec) {
                            scheduler.eventStore.remove(rec[0].data);
                        }
                    });
                }

                // >>> 2. getting back no Array ----------- (Hotel & Co.)
                if (objectOfRecords.response.length === undefined && objectOfRecords.response.id !== undefined) {
                    rec = scheduler.eventStore.findByField('originalId', objectOfRecords.response.id);
                    if (rec) {
                        scheduler.eventStore.remove(rec[0].data);
                    }
                }


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onClick_Delete_SingleDuty_Finally()


            /******************************************************************* 'Delete single Duty - Emit'
            * onClick_Delete_AllMarkedDuties()
            *
            * Desc: Handle 'Delete All marked Duties'.
            * Note: Check Calendar Grant.
            *
            * @param {Object} rec (Clicked Record)
            */
            onClick_Delete_AllMarkedDuties: function(rec) {

                let me = this,
                    markedEvents = this.get_selectedMultiEventsEntireRecord,
                    notGrantedDuties = [],
                    startDatesArray = [],
                    myParams = {
                        params:{
                            idBreaks: [],
                            idProceedings : [],
                            idStays: [],
                            idTrainings: []
                        },
                        recs: []
                    };


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_Delete_AllMarkedDuties');
                // >>> --------------------------------------------------------- PreCheck: Grant
                if (markedEvents.length > 0) {
                    markedEvents.forEach(event => {
                        if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.' + event.data.name.toLowerCase() })) {
                            if (!notGrantedDuties.includes(event.data.name.toLowerCase())) {
                                notGrantedDuties.push(event.data.name.toLowerCase());
                            }
                        }
                        startDatesArray.push(event.data.startDate);

                    });
                }

                if (notGrantedDuties.length > 0) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to delete ' + String(notGrantedDuties).toUpperCase()
                    });
                    return;
                }

                if (!Vue.prototype.$isActionAllowed({ datesToCheck: startDatesArray, isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                // >>> ---------------------------------------------------------
                if (markedEvents.length > 0) {
                    markedEvents.forEach(event => {
                        if (event.data.name !== 'FLIGHT' && event.data.name !== 'CHECKIN' && event.data.name !== 'CHECKOUT') {
                            if (event.data.name === 'HOTEL') {
                                myParams.params.idStays.push(event.data.originalId);
                                myParams.recs.push(event);
                            } else if (event.data.name === 'PROCEEDING') {
                                myParams.params.idProceedings.push(event.data.originalId);
                                myParams.recs.push(event);
                            } else if (event.data.name === 'TRAINING') {
                                myParams.params.idTrainings.push(event.data.originalId);
                                myParams.recs.push(event);
                            } else {
                                myParams.params.idBreaks.push(event.data.originalId);
                                myParams.recs.push(event);
                            }
                        }
                    });
                }



                // >>> --------------------------------------------------------- showin dialog?
                if (markedEvents.length > 0) {
                    if (this.agreeDeleteMulti === false) { // not yet agreed
                        this.dialogDeleteMulti = true;
                    } else {
                        this.agreeDeleteMulti = false;
                        this.dialogDeleteMulti = false;
                        this.actn_delete_AllMarkedDuties(myParams);
                    }
                }

            }, // eo function onClick_Delete_AllMarkedDuties()


            /******************************************************************* 'Delete single Duty Finally - Emit'
            * onClick_Delete_AllMarkedDuties_Finally()
            *
            * Desc: Handle 'Delete Single Duty Finally'.
            * Note: Delete the old Way. Via transported recs.
            * Note: Delete the new Way. Via apis response.
            *
            * @param {Object} rec (Clicked Record)
            */
            onClick_Delete_AllMarkedDuties_Finally: function(objectOfRecords) {

                let me = this,
                    rec = null,
                    scheduler = this.$refs.scheduler1.instance;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> onClick_Delete_AllMarkedDuties_Finally');
                // >>> ------------------------------------ 'idBreaks'
                objectOfRecords.response.idBreaks.forEach(id => {
                    rec = scheduler.eventStore.findByField('originalId', id);
                    if (rec) {
                        scheduler.eventStore.remove(rec[0].data);
                    }
                });

                // >>> ------------------------------------ 'idProceedings'
                objectOfRecords.response.idProceedings.forEach(id => {
                    rec = scheduler.eventStore.findByField('originalId', id);
                    if (rec) {
                        scheduler.eventStore.remove(rec[0].data);
                    }
                });

                // >>> ------------------------------------
                objectOfRecords.response.idStays.forEach(id => {
                    rec = scheduler.eventStore.findByField('originalId', id);
                    if (rec) {
                        scheduler.eventStore.remove(rec[0].data);
                    }
                });

                // >>> ------------------------------------
                objectOfRecords.response.idTrainings.forEach(id => {
                    rec = scheduler.eventStore.findByField('originalId', id);
                    if (rec) {
                        scheduler.eventStore.remove(rec[0].data);
                    }
                });


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onClick_Delete_AllMarkedDuties_Finally()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>
